import type { ReactNode } from 'react';

export const symbol_no_encryption: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M610-634v-95q0-54-38.85-92.5T476-860q-44 0-78.5 26.5T351-765q-4 13-13.5 20.5T317-739q-14-2-21.5-12.5T291-774q15-65 66.74-105.5Q409.48-920 476-920q80.91 0 137.46 55.87Q670-808.27 670-729v95h70q24.75 0 42.38 17.62Q800-598.75 800-574v265q0 15-9.32 22.5t-20.5 7.5q-11.18 0-20.68-7.68-9.5-7.69-9.5-22.32v-265H474q-15 0-22.5-9.32t-7.5-20.5q0-11.18 7.5-20.68T474-634h136ZM220-80q-24.75 0-42.37-17.63Q160-115.25 160-140v-434q0-23 16-40.5t39-19.5L7-842q-9-9-8.5-21T8-884q9-9 21-9t21 9L889-45q9 9 8.5 21T888-3q-9 9-21 9t-21-9l-82-82q-8 3-13 4t-11 1H220Zm490-60L535-314q-11 11-24.24 16-13.24 5-28.76 5-32 0-53.5-21T407-366.68q0-16.32 5.5-29.82T429-421L275-574h-55v434h490ZM493-357Zm113-84Z"
		/>
	</svg>
);
